import { normalizeBaseUrl } from "shared-utils";
import { Api as SuggestionsApi } from "../generated/SuggestionsApi";
import config from "../config";
import { createAxiosRequestInterceptors } from "../axios/axios-interceptors";

const suggestionsApi = new SuggestionsApi({
  baseURL: normalizeBaseUrl(config.suggestionsApiUrl),
});

createAxiosRequestInterceptors(suggestionsApi.instance);

export default suggestionsApi;
